/** @jsx jsx */
import { Component, h } from 'preact';
import { useMemo } from 'preact/hooks';
import { observer } from 'mobx-react-lite';
import { jsx, css } from '@emotion/react';

import { useController, Filter } from '@searchspring/snap-preact-components';

import './desktopfiltersummary.css';

export const DesktopFilterSummary = () => {
    const controller = useController();

    const { filters } = controller.store;

    const { urlManager } = controller;

    const removeFilter = (e, filter) => {
        const query = `filter.${filter.facet.field}`;

        urlManager.remove(query, filter.value.label).go();
    }

    const clearAll = () => {
        urlManager.remove('filter').go();
    }

    //For tags, trim out french__ prefix
    //Desktop active filters
    filters.forEach((filter, index) => {
        if(filter.label.includes("french")) {
            filters[index].label = filters[index].label.replace("french__", "");
        }

        filters[index].label = filters[index].label.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    });

    return (
        <div class="desktop-filter-summary">
            <span class="active-filters">
                {filters.map(filter => {
                    return (
                        <Filter
                            key={JSON.stringify(filter)}
                            valueLabel={filter.label}
                            onClick={e => removeFilter(e, filter)}
                        />
                    )
                })}
            </span>
            {filters.length > 0 && (
                <span class="clear-all">
                    <button onClick={clearAll}>Clear All</button>
                </span>
            )}
        </div>
    )
}
